var messages$1 = {
};

export { messages$1 as messages };
//# sourceMappingURL=en.json.mjs.map
